import { f as M, r as h, c as k, T as X, s as Y } from "../TableHead-CHDCNyl_.es.js";
import e, { useEffect as $ } from "react";
import t from "prop-types";
import D from "lodash";
import S from "classnames";
import j from "react-resize-observer";
import { w as G } from "../utils-C0l876fA.es.js";
import { d as W, T as F } from "../index-BB-Wk85r.es.js";
import { B as E } from "../Button-DVDXGoCp.es.js";
import { I as Q } from "../Icon-BuIPTPJn.es.js";
import { T as Z } from "../Tooltip-B-bmRvX4.es.js";
import { B as J, D as K } from "../DataTableShimmer-Lm9Dc2eK.es.js";
import '../index12.css';const V = "Cell-module__colHeader___mXp1B", ee = "Cell-module__rowHeader___R77wO", te = "Cell-module__cell___laxSz", le = "Cell-module__right___d8BNC", oe = "Cell-module__tooltip___Xb8LF", re = "Cell-module__link___v27Xb", ae = "Cell-module__text___QKfF0", ne = "Cell-module__stickyCol___dt3LC", C = {
  "data-table-border-height": "2px",
  "data-table-header-padding": "0.25rem",
  "data-table-row-height": "2rem",
  colHeader: V,
  rowHeader: ee,
  cell: te,
  right: le,
  tooltip: oe,
  link: re,
  text: ae,
  stickyCol: ne
}, T = (l) => {
  let a = null, c = "cell";
  l.colHeader ? (a = "col", c = "colHeader") : l.rowHeader && (a = "row", c = "rowHeader");
  const o = {
    className: S(
      C[c],
      l.align === "right" && C.right,
      l.fixedCol && M.fixedCol,
      l.stickyCol && C.stickyCol
    ),
    scope: a,
    tabIndex: 0
  }, n = /* @__PURE__ */ e.createElement(
    "div",
    {
      className: S(
        C.text,
        W["data-cell"],
        W.responsive
      )
    },
    l.children
  ), { LinkWrapper: s } = l, i = l.onCellClick || l.href ? /* @__PURE__ */ e.createElement(
    s,
    {
      className: C.link,
      href: l.href,
      onClick: (r) => {
        l.href || r.preventDefault(), l.onCellClick && l.onCellClick(r);
      }
    },
    n
  ) : n;
  return l.colHeader || l.rowHeader ? /* @__PURE__ */ e.createElement("th", { ...o }, i) : /* @__PURE__ */ e.createElement("td", { ...o }, i);
};
T.propTypes = {
  align: t.oneOf(["left", "right"]),
  children: t.node.isRequired,
  colHeader: t.bool,
  fixedCol: t.bool,
  // eslint-disable-next-line react/forbid-prop-types
  href: t.any,
  onCellClick: t.func,
  rowHeader: t.bool,
  LinkWrapper: t.elementType,
  stickyCol: t.bool
};
const se = (l) => /* @__PURE__ */ e.createElement("a", { ...l });
T.defaultProps = {
  align: "left",
  colHeader: !1,
  fixedCol: !1,
  href: null,
  onCellClick: null,
  rowHeader: !1,
  LinkWrapper: se,
  stickyCol: !1
};
const ie = (l) => `${l}`, g = (l) => /* @__PURE__ */ e.createElement("tbody", null, l.data.map((a, c) => (
  // eslint-disable-next-line react/no-array-index-key
  /* @__PURE__ */ e.createElement("tr", { key: c }, l.columns.map((o, n) => {
    const s = o.renderIcon && o.renderIcon(a[o.key]), i = s && typeof s == "object" ? /* @__PURE__ */ e.createElement(Q, { ...s }) : (o.renderCell || ie)(a[o.key]), r = o.tooltipContent && o.tooltipContent(a[o.key]);
    return /* @__PURE__ */ e.createElement(
      T,
      {
        key: n,
        align: o.align,
        fixedCol: n === 0,
        rowHeader: l.rowHeader && n === 0,
        onCellClick: o.onCellClick && ((_) => o.onCellClick(a, _)),
        href: o.href && o.href(a),
        LinkWrapper: o.LinkWrapper,
        stickyCol: n === 0 && l.stickFirstColumn
      },
      r && typeof r == "object" && r.content && r.props && (o.renderCell || s) ? /* @__PURE__ */ e.createElement(
        Z.Hover,
        {
          accessible: !0,
          trigger: i,
          ...r.props
        },
        r.content
      ) : i
    );
  }))
)));
g.propTypes = {
  columns: t.arrayOf(k.isRequired).isRequired,
  rowHeader: t.bool.isRequired,
  data: t.arrayOf(h.isRequired).isRequired,
  stickFirstColumn: t.bool
};
g.defaultProps = {
  stickFirstColumn: !1
};
const p = Object.freeze({
  DEFAULT: Symbol("default"),
  LOADING: Symbol("loading"),
  SUCCESS: Symbol("success"),
  ERROR: Symbol("error"),
  RETRY: Symbol("retry")
}), ce = "DataTable-module__table___ZocT8", me = "DataTable-module__scrollWrapper___1txvM", de = "DataTable-module__blurContainer___rueBz", ue = "DataTable-module__paginationSummary___OKUsC", fe = "DataTable-module__summaryWithFootnote___eIMAC", Ce = "DataTable-module__footnote___gzY6C", _e = "DataTable-module__footer___-i8tv", m = {
  table: ce,
  scrollWrapper: me,
  blurContainer: de,
  paginationSummary: ue,
  summaryWithFootnote: fe,
  footnote: Ce,
  footer: _e
}, v = ({
  buttonText: l,
  buttonStatus: a,
  initialLoadStatus: c,
  sortStatus: o,
  columns: n,
  data: s,
  footnote: i,
  loadMore: r,
  totalCount: _,
  rowHeader: O,
  sortBy: R,
  sortColumn: w,
  sortDirection: H,
  stickyHeader: N,
  t: u
}) => {
  const [b, P] = e.useState(!1), [q, B] = e.useState(!1), d = e.createRef(), y = () => {
    P(
      D.get(d.current, "scrollWidth") > D.get(d.current, "clientWidth")
    );
  };
  $(y, [y]);
  const U = {
    "view all": u("view all"),
    "load more": u("load more"),
    "view more": u("view more")
  }, I = () => {
    B((f) => {
      const x = d.current.scrollWidth - d.current.scrollLeft - d.current.clientWidth < 1;
      return f !== x ? { newScrolledRight: x } : {};
    });
  }, z = (f) => {
    f === w ? R(f, H === "asc" ? "desc" : "asc") : R(f, "asc");
  }, A = i ? m.summaryWithFootnote : m.paginationSummary;
  return /* @__PURE__ */ e.createElement("div", { "aria-live": "polite", "data-testid": "data-table-parent" }, /* @__PURE__ */ e.createElement(j, { onResize: y }), c === p.SUCCESS ? /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
    "div",
    {
      className: S({
        [m.scrollWrapper]: b
      }),
      ref: d,
      onScroll: I
    },
    b && !q && /* @__PURE__ */ e.createElement("div", { className: m.blurContainer }),
    /* @__PURE__ */ e.createElement("table", { className: m.table, "aria-live": "polite" }, /* @__PURE__ */ e.createElement(
      X,
      {
        columns: n,
        stickFirstColumn: b,
        sortBy: z,
        sortColumn: w,
        sortDirection: H,
        stickyHeader: N
      }
    ), o !== p.SUCCESS ? /* @__PURE__ */ e.createElement(J, { numCols: 6, numRows: 10 }) : /* @__PURE__ */ e.createElement(
      g,
      {
        columns: n,
        data: s,
        rowHeader: O,
        stickFirstColumn: b
      }
    )),
    r && /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
      E.MutedButton,
      {
        status: a,
        handleClick: r,
        disabled: s.length === _,
        fullWidth: !0
      },
      U[l]
    ))
  ), /* @__PURE__ */ e.createElement("div", { className: m.footer }, i && /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("div", { className: m.footnote }, /* @__PURE__ */ e.createElement(F.DataPagination, { responsive: !0 }, i))), /* @__PURE__ */ e.createElement("div", { className: A }, /* @__PURE__ */ e.createElement(F.DataPagination, { responsive: !0 }, u("dataTableRows", {
    rows: s.length,
    total: _
  }))))) : /* @__PURE__ */ e.createElement("div", { "aria-label": u("loading") }, /* @__PURE__ */ e.createElement(K, { numCols: 6, numRows: 10 })));
};
v.propTypes = {
  /** The text on the big button to load more data in the modal. */
  buttonText: t.oneOf(["view more", "load more", "view all"]),
  /** Status of the button, supports predefined status(DEFAULT, LOADING, SUCCESS, ERROR, RETRY) from Button.Status */
  buttonStatus: t.oneOf(Object.values(E.Status)),
  /** Data representing the labels of the tables of the columns and how to render a generic cell within the column. */
  columns: t.arrayOf(k.isRequired).isRequired,
  /** The data in the table. Array index corresponds to the row in the table, and the key-value pairs in each entry correspond to the data appearing in the columns of the row. This prop should be JSON-serialisable. */
  data: t.arrayOf(h.isRequired).isRequired,
  /** a message to be displayed beneath the footer */
  footnote: t.string,
  /** Status of the initial datatable load, supports status(DEFAULT, LOADING, SUCCESS, ERROR, RETRY). May need updated once async actions are supported for DataTables */
  initialLoadStatus: t.symbol,
  /** Gets called upon clicking the 'view more' button, and determines if the button will show in the table. */
  loadMore: t.func,
  /** The total rows of data (number of results) that can possibly be loaded into the table. */
  totalCount: t.number.isRequired,
  /** Renders the first column of the table as a header when true (with a ruling on the right-hand-side and accessibility data). */
  rowHeader: t.bool,
  /** Gets called on clicking on a sortable column header cell. It will pass the column key of the column clicked on, and the new sort direction, and should update the sortColumn and sortDirection prop values. */
  sortBy: t.func,
  /** Sort table by this column's values descending. */
  sortColumn: t.string,
  /** The direction of the sorting on the current sortColumn. */
  sortDirection: Y,
  /** Status of async sorting on the DataTable, supports status(DEFAULT, LOADING, SUCCESS, ERROR, RETRY). May need updated once async actions are supported for DataTables */
  sortStatus: t.symbol,
  /** Renders the header, if there is one, as a fixed sticky header that persists on scroll */
  stickyHeader: t.bool,
  /** MRUI's translate function, (automatically added to the component) */
  t: t.func.isRequired
};
v.defaultProps = {
  buttonStatus: E.Status.DEFAULT,
  buttonText: "view more",
  footnote: null,
  initialLoadStatus: p.SUCCESS,
  loadMore: void 0,
  rowHeader: !1,
  sortBy: () => {
  },
  sortColumn: void 0,
  sortDirection: void 0,
  sortStatus: p.SUCCESS,
  stickyHeader: !0
};
const L = G(v);
L.columnPropType = k;
L.rowPropType = h;
export {
  L as default
};
